// src/utils/freeTransfers.js
// Single source of truth for the "unlimited free transfers" concept.
//
// Canonical persisted representation is the string "unlimited".
// Historically PickTeam used 999 as an in-memory sentinel, and some docs were
// accidentally written back as the number 999/1000. To render and calculate
// correctly regardless of how the value was stored, treat any of these as
// unlimited:
//   - the string "unlimited"
//   - Infinity
//   - any number >= UNLIMITED_FT_THRESHOLD (sentinel leakage like 999/1000)

export const UNLIMITED_FT = "unlimited";
export const UNLIMITED_FT_SENTINEL = 999;
export const UNLIMITED_FT_THRESHOLD = 999;

export function isUnlimitedFT(value) {
  if (value === UNLIMITED_FT) return true;
  if (value === Infinity) return true;
  if (typeof value === "number" && value >= UNLIMITED_FT_THRESHOLD) return true;
  return false;
}
